module.exports = __webpack_public_path__ + "img/LNZ18.9e924db4.jpg";